"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesAutocompleteField = void 0;
const react_1 = __importDefault(require("react"));
const components_common_map_pin_1 = require("@hotelplan/components.common.map-pin");
const fdr_lib_router_push_1 = require("@hotelplan/fdr.lib.router.push");
const fdr_agency_autocomplete_input_1 = require("./fdr-agency-autocomplete-input");
const fdr_agency_map_search_types_1 = require("./fdr-agency-map-search.types");
const AgenciesAutocompleteField = props => {
    const { className, map, autocompleteDataSource, selected, onChange, onSearchAroundMe, children, } = props;
    const { transfer } = (0, fdr_lib_router_push_1.useTransfer)();
    function onSelect(next) {
        if (!next) {
            return onChange(undefined);
        }
        if (next.type === fdr_agency_map_search_types_1.AgenciesSuggestionType.AGENCY) {
            transfer(next.url, false, true);
        }
        else if (next.type === fdr_agency_map_search_types_1.AgenciesSuggestionType.MAP_OBJECT) {
            onChange(next);
            if (map) {
                map.setCenter((0, components_common_map_pin_1.mapCoordinatesToLatLng)(next.coordinates));
                map.setZoom(next.zoom);
            }
        }
    }
    return (react_1.default.createElement(fdr_agency_autocomplete_input_1.AgenciesAutocompleteInput, { onSelect: onSelect, onSearchAroundMe: onSearchAroundMe, selected: selected, className: className },
        autocompleteDataSource,
        children));
};
exports.AgenciesAutocompleteField = AgenciesAutocompleteField;
//# sourceMappingURL=fdr-agency-autocomplete-field.js.map